module.exports = __webpack_public_path__ + "img/orange-lily.81a58416.webp";